import { Button, Checkbox, Form, Input, Modal, Select } from 'antd';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import { STATUS } from 'constants/reponseStatus';
import {
  IGroup,
  IJobTitle,
  IMappingJobTitle,
} from 'interface/permission.interface';
import { mockRoleUser } from 'mock/route-mangagement';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import handleError401 from 'utils/handleError401';
import { openNotificationWithIcon } from 'utils/notification';

interface IProps {
  isModalVisible: boolean;
  onCancel: () => void;
  mutationUser: (data: any) => void;
  jobtitle?: any;
}

const formLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const { Option } = Select;

export default function UpdateMappingJobTitleModal(props: IProps): JSX.Element {
  const { isModalVisible, onCancel, mutationUser, jobtitle } = props;
  const [roles, setRoles] = useState([]);

  const [form] = Form.useForm();

  // const { mutate: getRoles } = useMutation(
  //   ['getRoles'],
  //   () => RoleBasedAuth.getRoles(),
  //   {
  //     onSuccess: (response: any) => {
  //       if (response.status === STATUS.SUCCESS) {
  //         setRoles(response?.data);
  //       }
  //     },
  //     onError: (error: any) => {
  //       openNotificationWithIcon('error', error.toString());
  //     },
  //   }
  // );

  useEffect(() => {
    form.setFieldsValue(jobtitle);
  }, [jobtitle]);

  // useEffect(() => {
  //   getRoles();
  // }, []);

  return (
    <Modal
      title="Cập nhật Role - Job Title"
      visible={isModalVisible}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        form={form}
        name="create_mapping_job_title"
        onFinish={mutationUser}
        initialValues={jobtitle}
        className="bg-white p-2 gap-4 lg:w-90 md:w-90 sm:w-100"
        validateMessages={{
          required: '${label} không được để trống!',
        }}
        {...formLayout}
      >
        <Form.Item label="Job title" name="job_title_code">
          {/* <Input name="jobTitleCode" placeholder="PNJ.CODE.123" /> */}
          {jobtitle && (
            <Select placeholder="Chọn Job Title" disabled>
              <Option
                value={jobtitle?.job_title_code}
                key={jobtitle?.job_title_code}
              >
                {jobtitle?.job_title}
              </Option>
            </Select>
          )}
        </Form.Item>

        <Form.Item label="Quyền" name="role">
          <Select
            // defaultValue={currentUser?.role}
            allowClear
          >
            {mockRoleUser?.map((group) => (
              <Option key={group?.id} value={group?.value}>
                {group?.title}
              </Option>
            ))}

            {/* {roles?.map((group: any) => (
              <Option key={group?.id} value={group?.role}>
                {group?.role_name}
              </Option>
            ))} */}
          </Select>
        </Form.Item>

        <Form.Item className="flex items-center justify-center">
          <Button type="primary" htmlType="submit" className="bg-primary">
            Cập nhật
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
